export default __webpack_public_path__ + "static/media/about_me.d17d519d.png";